/**
 * The Thyme app URL. The "Go to app" CTA in the header and footer links here.
 */
export const APP_URL = 'https://app.thyme.money';
